import type { ReactNode } from "react";
import { Column } from "@hightouch/htui";

import {
  MEDIA_DETAIL_PANEL_WIDTH,
  MEDIA_DETAIL_SPLIT_QUERY,
} from "src/components/media-detail/constants";

type Props = {
  children: ReactNode;
};

/** The details. A scrolling panel beside the preview, or a column below it. */
export function MediaDetailDetails({ children }: Props) {
  return (
    <Column
      as="section"
      alignSelf="center"
      w={MEDIA_DETAIL_PANEL_WIDTH}
      maxW="100%"
      minW={0}
      gap={6}
      sx={{
        [MEDIA_DETAIL_SPLIT_QUERY]: {
          alignSelf: "stretch",
          maxW: "none",
          flexShrink: 0,
          w: MEDIA_DETAIL_PANEL_WIDTH,
          h: "100%",
          overflowY: "auto",
          bg: "white",
          borderLeftWidth: "hairline",
          borderLeftStyle: "solid",
          borderLeftColor: "base.divider",
          px: 6,
          py: 6,
        },
      }}
    >
      {children}
    </Column>
  );
}
